import {EGroup} from './types';

export default {
  select: 'Select emoji',
  search: 'Search',
  searchResult: 'Search result',
  notFound: 'Emoji not found',
  empty: 'Empty',
  group: {
    [EGroup.recent]: 'Frequently used',
    [EGroup.smileys]: 'Smileys and Emotion',
    [EGroup.people]: 'People',
    [EGroup.animals_and_nature]: 'Animals and nature',
    [EGroup.food_and_drink]: 'Food and drinks',
    [EGroup.activity]: 'Actions',
    [EGroup.travel_and_places]: 'Travel and places',
    [EGroup.objects]: 'Objects',
    [EGroup.symbols]: 'Characters',
    [EGroup.flags]: 'Flags',
  },
};
